import { useState } from 'react';
import ReactModal from 'react-modal';
import useKeypress from '../ownHooks/pressEsc';
import { strKatForm } from '../Tabellen/ConstTabKopf/StreckenkatKopf';
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from '../Fehler/FehlerauswertungErrResp';

var MonitorApi = require('monitor-api');

export default function StrKatCreate({ strKatInstance, reloadData }) {
    const attributes = strKatForm;
    const [newStrKat, setNewStrKat] = useState(new MonitorApi.CreateStreckenkategorie());
    const [showModal, setShowModal] = useState(false);

    useKeypress('Escape', () => {
        closeModal();
    });

    const openModal = () => {
        setNewStrKat(new MonitorApi.CreateStreckenkategorie());
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const changingInput = event => {
        event.preventDefault();
        setNewStrKat(previous => ({ ...previous, [event.target.name]: event.target.value }))
    }

    const submitForm = event => {
        event.preventDefault();
        let creating = new Promise((resolve) => {
            strKatInstance.createStreckenkategorieStreckenkategoriePost(newStrKat, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Neue Streckenkategorie ${data.name} hinzugefügt.\nMit Id: ${data.id}`);
                    resolve(data);
                }
            })
        })
        creating.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neue Streckenkategorie</MyNewButton>
            <ReactModal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm}>
                    <h3>Neue Kategorie:</h3>
                    {attributes.map((column, index) => {
                        return (
                            <MyModalContentRow key={index}>
                                {<label>{`${column.Header}: `}
                                    <MyModalContentTextInput name={column.accessor} onChange={changingInput} required />
                                </label>}
                            </MyModalContentRow>
                        )
                    })}
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </ReactModal>
        </div>
    )
}